<template>
  <div :class="classes">
    <img v-if="logo" :src="logo" :class="$style.logo" alt="logo" />
    <div :class="$style['info-msg']">
      {{ computedInfoMsg }}
      <icon v-if="!disabled" :class="$style.icon" :name="computedIcon" />
    </div>
    <div :class="$style['primary-text']">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    loading: Boolean,
    error: Boolean,
    disabled: Boolean,
    success: Boolean,
    logo: String,
    customMsg: String,
  },
  computed: {
    classes() {
      return {
        [this.$style['list-item']]: true,
        [this.$style.error]: this.error,
        [this.$style.disabled]: this.disabled,
        [this.$style.success]: this.success,
        [this.$style['gray-icon']]: this.computedTheme === 'light-gray',
      };
    },
    computedIcon() {
      if (this.loading) {
        return 'loader-alt';
      }
      if (this.error) {
        return 'exclamation';
      }
      if (this.success) {
        return 'checkmark';
      }

      return 'arrows';
    },
    computedTheme() {
      if (this.error) {
        return 'red';
      }
      if (this.success) {
        return 'teal';
      }

      return 'light-gray';
    },
    computedInfoMsg() {
      if (this.error) {
        return this.customMsg || 'Please try again';
      }
      if (this.loading) {
        return this.customMsg || 'Connection can take up 24hrs';
      }
      if (this.disabled) {
        return this.customMsg || 'Disabled';
      } else if (this.customMsg) {
        return this.customMsg;
      }

      return '';
    },
  },
};
</script>

<style lang="less" module>
.list-item {
  position: relative;
  font-family: @regular-font;
  font-weight: normal;
  height: 40px;
  background: @color-white;
  border-bottom: 1px solid @color-lightgray-300;
  line-height: 41px;
  padding: 0 @gutter-10;
  cursor: pointer;
  @media only screen and (max-width: 500px) {
    height: 70px;
  }
  &:hover {
    background: @color-lightgray-100;

    &.gray-icon .icon {
      background: @color-white;
    }
  }

  &.disabled {
    color: @color-gray;
    pointer-events: none;
  }

  .info-msg {
    font-size: @font-size-10;
    position: absolute;
    top: 10px;
    right: 10px;
    line-height: 18px;
    color: @color-black;
    @media only screen and (max-width: 500px) {
      top: 25px;
      right: 25px;
    }
    .error& {
      color: @color-red;
    }

    .disabled& {
      color: @color-gray;
    }

    .success& {
      color: @color-teal;
    }

    .icon {
      margin-left: 15px;
      width: 26px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }
  }

  .primary-text {
    @media only screen and (max-width: 500px) {
      line-height: 70px;
    }
  }
}
.logo {
  height: 20px;
  width: 100px;
  margin: 10px;
  @media only screen and (max-width: 500px) {
    margin-top: 25px;
    margin-bottom: 25px;
  }
}
</style>
